import { DECIMAL_TO_PERCENT } from 'common/constants/math';

export const getProgressPercent = ({ lengthComputable, loaded, total }: ProgressEvent) =>
  lengthComputable ? (loaded / total) * DECIMAL_TO_PERCENT : DECIMAL_TO_PERCENT;
